import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa0af186"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kitchensink-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = {
  key: 0,
  class: "line1"
}
const _hoisted_4 = {
  key: 1,
  class: "line2"
}
const _hoisted_5 = { class: "input-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Item name *", -1))
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_10 = { class: "input-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Item description *", -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_15 = { class: "row mt-4" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isLoadingData)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalBox, {
      show: _ctx.show,
      "onUpdate:show": _cache[6] || (_cache[6] = $event => ((_ctx.show) = $event)),
      onClose: _cache[7] || (_cache[7] = $event => (_ctx.cancelClicked()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          true
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Add new item"))
            : _createCommentVNode("", true),
          true
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Row 2"))
            : _createCommentVNode("", true)
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.mockData.name) = $event)),
            disabled: _ctx.isLoadingData,
            placeholder: "Placeholder text here",
            maxlength: "199",
            onInput: _cache[1] || (_cache[1] = $event => (_ctx.mandatoryCheck())),
            maxLength: "20"
          }, null, 40, _hoisted_7), [
            [_vModelText, _ctx.mockData.name]
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["footnote", [ _ctx.mockData.name.length === 20 ? 'full' : '']])
          }, _toDisplayString(_ctx.mockData.name.length) + "/20 characters ", 3),
          (_ctx.mockData.name === '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createTextVNode(" Mandatory field ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.mockData.desc) = $event)),
            disabled: _ctx.isLoadingData,
            placeholder: "Placeholder text here",
            maxlength: "199",
            onInput: _cache[3] || (_cache[3] = $event => (_ctx.mandatoryCheck())),
            maxLength: "75"
          }, null, 40, _hoisted_12), [
            [_vModelText, _ctx.mockData.desc]
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["footnote", [ _ctx.mockData.desc.length === 75 ? 'full' : '']])
          }, _toDisplayString(_ctx.mockData.desc.length) + "/75 characters ", 3),
          (_ctx.mockData.desc === '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _createTextVNode(" Mandatory field ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[4] || (_cache[4] = $event => (_ctx.cancelClicked())),
            disabled: _ctx.isLoadingData
          }, "Cancel", 8, _hoisted_16),
          _createElementVNode("button", {
            class: "btn btn-primary ml-2",
            disabled: !_ctx.canSubmit || _ctx.isLoadingData,
            onClick: _cache[5] || (_cache[5] = $event => (_ctx.submit()))
          }, [
            _createTextVNode("Update "),
            _hoisted_18
          ], 8, _hoisted_17)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}